import { render, staticRenderFns } from "./ChangeMaterialVariantOrigin.vue?vue&type=template&id=a3bdbe18&scoped=true"
import script from "./ChangeMaterialVariantOrigin.vue?vue&type=script&lang=js"
export * from "./ChangeMaterialVariantOrigin.vue?vue&type=script&lang=js"
import style0 from "./ChangeMaterialVariantOrigin.vue?vue&type=style&index=0&id=a3bdbe18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3bdbe18",
  null
  
)

export default component.exports